import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedNumber } from 'react-intl';

const FormattedCurrencyNumber = ({
  value,
  style,
  currency,
}) => {
  const decimalMask = useSelector(state => state.serviceCenter.isDecimal);

  return <FormattedNumber
    value={value}
    style={style}
    currency={currency}
    maximumFractionDigits={decimalMask ? 2 : 0}
  />;
};

FormattedCurrencyNumber.propTypes = {
  value: PropTypes.string,
  style: PropTypes.string,
  currency: PropTypes.string,
};

export default FormattedCurrencyNumber;
